import {DigitalAssetVisual} from '@cohort/components-xps/components/DigitalAssetVisual';
import {NftTitleBlock} from '@cohort/components-xps/components/NftTitleBlock';
import {CampaignContentMobile} from '@cohort/wallet/components/CampaignContentMobile';
import BuyButton from '@cohort/wallet/components/store/BuyButton';
import PriceLabel from '@cohort/wallet/components/store/PriceLabel';
import useStoreContext from '@cohort/wallet/hooks/useStoreContext';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import StorePage from '@cohort/wallet/layouts/store/StorePage';
import React from 'react';
import {useTranslation} from 'react-i18next';

const CampaignPageMobile: React.FC = () => {
  const {campaign, price, setCurrency} = useStoreContext();
  const {accentColor, hasDarkBg} = useThemeContext();
  const {t} = useTranslation('layouts', {keyPrefix: 'store.storeMobileLayout'});

  return (
    <StorePage
      title={campaign.collection.name}
      tracking={{
        namespace: 'store.campaign',
      }}
    >
      <div className="space-y-8 px-5">
        <div className="m-auto w-1/2 pt-5">
          <DigitalAssetVisual
            digitalAssetImageFileKey={campaign.collection.imageFileKey}
            animationFileKey={campaign.collection.animationFileKey}
          />
        </div>
        <div className="w-full space-y-8">
          <div className="w-full">
            <NftTitleBlock
              hasDarkBg={hasDarkBg}
              pretitle={t('typeOfProduct')}
              title={campaign.collection.name}
              subtitle={
                price === null ? (
                  t('free')
                ) : (
                  <PriceLabel
                    price={price}
                    prices={campaign.store.prices}
                    setCurrency={setCurrency}
                  />
                )
              }
              additionnalCssStyleOnAccent={{color: accentColor}}
            />
          </div>

          <BuyButton />
        </div>
      </div>
      <CampaignContentMobile />
    </StorePage>
  );
};

export default CampaignPageMobile;
